const currentPath = window.location.pathname.toLowerCase();
const autoStart = /\/pages\/skin-advisor\/?$/.test(currentPath);

if (autoStart) {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.async = true;

  script.onload = function () {
    script.remove();
  };
  if (typeof window.globalOSAUrl === "undefined") {
    const shopHost =
      (window.Shopify && window.Shopify.shop) ||
      window.location.hostname;
    window.globalOSAUrl = (shopHost.includes("x36ngn-ms") || shopHost.includes("olay-9759"))
      ? "https://skinadvisor.olay.com/"
      : "https://stage-skinadvisor.olay.com/";
  }
  
  script.src = `${window.globalOSAUrl}js/widget.js`;
  
  document.getElementsByTagName("head")[0].appendChild(script);

  const OSA_ORIGIN = (
    window.globalOSAUrl || "https://skinadvisor.olay.com"
  ).replace(/\/$/, "");

  let iframeElement = null;

  const iframeObserver = new MutationObserver(() => {
    const el = document.getElementById("madonna-widget-frame");
    if (el) {
      iframeElement = el;
      iframeObserver.disconnect();

      // Call sendJwtToOSA once the iframe content is fully loaded
      el.addEventListener("load", (event) => {    
        if (event.type === "load") {          
          setTimeout(() => sendJwtToOSA(), 3000);
        }
      });
    }
  });
  iframeObserver.observe(document.body, { childList: true, subtree: true });

  function sendJwtToOSA() {
    // Determine if customer is logged in
    const isCustomerLoggedIn = !!window.customerId;
    iframeElement = document.getElementById("madonna-widget-frame");
    if (!iframeElement) {
      return;
    }

    iframeElement.contentWindow.postMessage(
      {
        type: "OSA_AUTH",
        customerEmail: window.customerEmail || null,
        isLoggedIn: isCustomerLoggedIn,
        ts: Date.now(),
      },
      OSA_ORIGIN,
    );
  }
}
